import { useState } from 'react';
import { useDispatch } from 'react-redux';

import type { RemoveItemParams } from 'features/order/substitution-flow/domain';
import {
  getPartnerId,
  logAnalyticSFRemoveItem,
  removeItemFromOrder,
} from 'features/order/substitution-flow/infra';
import { useTLang } from 'intl/intl';
import appActions from 'redux/actions/app-actions/app.actions';
import orderActions from 'redux/actions/orders-actions/orders.actions';

import { useSubstitutionFlowDeleteItemBtnLang } from './useSubstitutionFlowDeleteItemBtnLang';

const SNACKBAR_ERROR_DURATION_MS = 5_000;

export function useSubstitutionFlowDeleteItemBtn(props: RemoveItemParams) {
  const { isProduct } = props;
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const dispatch = useDispatch();
  const errorTitle = useTLang({ id: 'customSnackbar.errorTitle' });
  const errorMessage = useTLang({ id: 'substitutionFlow.005' });
  const {
    deleteProductLabel,
    deleteToppingLabel,
  } = useSubstitutionFlowDeleteItemBtnLang();
  const deleteItemLabel = isProduct ? deleteProductLabel : deleteToppingLabel;

  const openConfirm = () => setIsConfirmOpen(true);
  const closeConfirm = () => setIsConfirmOpen(false);

  const _handleException = () => {
    dispatch(
      appActions.openSnackBarError(
        errorMessage,
        errorTitle,
        SNACKBAR_ERROR_DURATION_MS,
      ),
    );
  };

  const confirmDelete = async () => {
    closeConfirm();
    try {
      const isSuccess = await removeItemFromOrder(props);
      if (!isSuccess) {
        _handleException();
        return;
      }
      logAnalyticSFRemoveItem({
        partnerId: getPartnerId(),
        storeId: props.storeId,
        orderId: props.orderId,
        itemId: props.itemId,
        type: props.isProduct ? 'product' : 'topping',
      });
      dispatch(orderActions.loadOrderDetailDialog());
    } catch {
      _handleException();
    }
  };

  return {
    deleteItemLabel,
    isConfirmOpen,
    openConfirm,
    closeConfirm,
    confirmDelete,
  };
}
